import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { getSelectedBusiness } from 'libs/workroom/data/stores/business/business.selectors';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

import { UserBusiness } from '@offconon/core-api';
import { ProfileMiniComponent } from '@offconon/shared/ui/profile-mini';
import { MrAiWorkingComponent } from '@offconon/shared/ui/skeleton-render';
import { EnvironmentService } from '@offconon/shared/utils/services/environment';

@Component({
  selector: 'offconon-erp-employee-profile',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MenuModule,
    MrAiWorkingComponent,
    ButtonModule,
    MatIcon,
    ProfileMiniComponent,
  ],
  templateUrl: './erp-employee-profile.component.html',
  styles: ``,
})
export class ErpEmployeeProfileComponent implements OnInit {
  private environmentService = inject(EnvironmentService);
  selectedBusiness: UserBusiness;

  private router = inject(Router);
  private translateService = inject(TranslateService);
  private store$ = inject(Store);

  loading = true;

  items: MenuItem[];

  business_data: any;
  full_name: any;
  avatar_path: any;
  username: any;
  profile_link = '/';
  settings_link = '/';
  monogram_class = 'ml-auto mt-2';
  employee_id: any;
  job_title_name: any;

  profile_mini_parameters: any = {};

  ngOnInit() {
    this.store$.select(getSelectedBusiness).subscribe((res) => {
      this.selectedBusiness = res as UserBusiness;

      if (this.selectedBusiness) {
        this.job_title_name = this.selectedBusiness?.job_title_name;
        this.full_name = this.selectedBusiness?.business_user_full_name;
        this.avatar_path = this.selectedBusiness?.business_co_worker_avatar_path;
        this.username = this.selectedBusiness?.business_user_name;
        this.employee_id = this.selectedBusiness?.business_co_worker_id;
        this.profile_link = '/co-workers/profile/' + this.employee_id;
        this.settings_link = '/my-corporate-profile-settings';
        this.renderBusinessMenu();
        this.loading = false;
      }

      this.profile_mini_parameters = {
        is_online_show: false,
        full_name: this.full_name,
        avatar_path: this.avatar_path,
        is_online: true,
        username: this.username,
        is_subscription: false,
        is_verified: false,
        subscription_icon: undefined,
        subscription_color: undefined,
        subscription_name: undefined,
        job_title_name: undefined,
      };
    });
  }

  renderBusinessMenu() {
    this.items = [
      {
        label: this.translateService.instant('Manage'),
        items: [
          {
            label: this.translateService.instant('Employee profile'),
            icon: 'badge',
            command: () => {
              this.openSubPage(this.profile_link);
            },
          },
          {
            label: this.translateService.instant('Profile settings'),
            icon: 'edit_note',
            command: () => {
              this.openSubPage(this.settings_link);
            },
          },
        ],
      },
      {
        label: this.translateService.instant('Options'),
        items: [
          {
            label: this.translateService.instant('Business networking'),
            icon: 'handshake',
            command: () => {
              this.onCoreSubPage('/bizconnect/members');
            },
          },
        ],
      },
    ];

    this.loading = false;
  }

  openSubPage(url: any) {
    this.router.navigate([url]);
  }

  onCoreSubPage(url: any) {
    window.open(`${this.environmentService.environment.coreUrl}${url}`, '_blank');
  }
}
